import { Member } from "@app/models/myoffice/member/member.model";
import { ResultProc } from "@app/models/system/result-proc.model";
import { holdingTankFeatureKey } from "@app/reducers/myoffice/member/holding-tank.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export interface HoldingTankState {
    memberNullPid: Member[];
    total: Number;
    result: ResultProc;
}

export const getMemberNullPidState = createFeatureSelector<HoldingTankState>(holdingTankFeatureKey);

export const findMemberNullPid = createSelector(
    getMemberNullPidState,
    (state: HoldingTankState) => state.memberNullPid
)

export const countMemberNullPid = createSelector(
    getMemberNullPidState,
    (state: HoldingTankState) => state.total
)

export const savePid = createSelector(
    getMemberNullPidState,
    (state: HoldingTankState) => state.result
)